import {
  SetLens2527bvop19mpo as SetLens,
  ModifyLens104zsbx7gwa6e as ModifyLens,
  SetValueLensuxj8ukufftbv as SetValueLens,
  ModifyValueLenspp00mwqm1elc as ModifyValueLens,
} from '../abstracts.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from './IssueNode.mjs';
import {
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
  MutableValidated2ognu5vxf17ur as MutableValidated,
  lens2gvfhjoqnpofs as lens_1,
  lens2wuprihu5z787 as lens_2,
  MutableValidatedValuegls7jkstsdwb as MutableValidatedValue,
} from './Validated.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ValidatedSetLensClass;
function ValidatedSetLens() {
  if (ValidatedSetLensClass === VOID) {
    class $ extends SetLens() {
      static dau(source, get, set) {
        var $this = this.cap(source, get, set);
        $this.cau_1 = new (IssueNode())(source.vat());
        return $this;
      }
      vat() {
        return this.cau_1;
      }
      ial() {
        super.ial();
        this.cau_1.uat();
      }
      jal() {
        super.jal();
        this.cau_1.qat();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, 'ValidatedSetLens', VOID, VOID, [MutableValidated(), SetLens()], [1]);
    ValidatedSetLensClass = $;
  }
  return ValidatedSetLensClass;
}
var ValidatedModifyLensClass;
function ValidatedModifyLens() {
  if (ValidatedModifyLensClass === VOID) {
    class $ extends ModifyLens() {
      static lau(source, get, modify) {
        var $this = this.jap(source, get, modify);
        $this.kau_1 = new (IssueNode())(source.vat());
        return $this;
      }
      vat() {
        return this.kau_1;
      }
      ial() {
        super.ial();
        this.kau_1.uat();
      }
      jal() {
        super.jal();
        this.kau_1.qat();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, 'ValidatedModifyLens', VOID, VOID, [MutableValidated(), ModifyLens()], [1]);
    ValidatedModifyLensClass = $;
  }
  return ValidatedModifyLensClass;
}
var ValidatedSetValueLensClass;
function ValidatedSetValueLens() {
  if (ValidatedSetValueLensClass === VOID) {
    class $ extends SetValueLens() {
      static tau(source, get, set) {
        var $this = this.qap(source, get, set);
        $this.sau_1 = new (IssueNode())(source.vat());
        return $this;
      }
      vat() {
        return this.sau_1;
      }
      ial() {
        super.ial();
        this.sau_1.uat();
      }
      jal() {
        super.jal();
        this.sau_1.qat();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).tak = lens_1;
    protoOf($).bak = lens_2;
    initMetadataForClass($, 'ValidatedSetValueLens', VOID, VOID, [MutableValidatedValue(), SetValueLens()], [1]);
    ValidatedSetValueLensClass = $;
  }
  return ValidatedSetValueLensClass;
}
var ValidatedModifyValueLensClass;
function ValidatedModifyValueLens() {
  if (ValidatedModifyValueLensClass === VOID) {
    class $ extends ModifyValueLens() {
      static bav(source, get, modify) {
        var $this = this.xap(source, get, modify);
        $this.aav_1 = new (IssueNode())(source.vat());
        return $this;
      }
      vat() {
        return this.aav_1;
      }
      ial() {
        super.ial();
        this.aav_1.uat();
      }
      jal() {
        super.jal();
        this.aav_1.qat();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).tak = lens_1;
    protoOf($).bak = lens_2;
    initMetadataForClass($, 'ValidatedModifyValueLens', VOID, VOID, [MutableValidatedValue(), ModifyValueLens()], [1]);
    ValidatedModifyValueLensClass = $;
  }
  return ValidatedModifyValueLensClass;
}
//region block: exports
export {
  ValidatedModifyLens as ValidatedModifyLensxnr6y4izl6zn,
  ValidatedModifyValueLens as ValidatedModifyValueLensyxkqbmnu4076,
  ValidatedSetLens as ValidatedSetLens3tjmcbmmtgp0c,
  ValidatedSetValueLens as ValidatedSetValueLens1a0iz59dg9w6t,
};
//endregion

//# sourceMappingURL=validationLenses.mjs.map
